// extracted by mini-css-extract-plugin
export default {"loader":"ConnectionLoader_loader__gK2yw"};